/**
 * 변형 데이터 계산 클래스
 * polygon의 center, rotation, scaleFactor를 계산합니다.
 */
export class TransformationCalculator {
  /**
   * 중심점 계산
   * @param {Array} coordinates - 좌표 배열
   * @returns {Array} 중심점 [x, y]
   */
  calculateCenter(coordinates) {
    const xs = coordinates.map(coord => coord[0]);
    const ys = coordinates.map(coord => coord[1]);

    return [
      (Math.min(...xs) + Math.max(...xs)) / 2,
      (Math.min(...ys) + Math.max(...ys)) / 2
    ];
  }

  /**
   * 회전각 계산 (라디안)
   * @param {Array} coordinates - 좌표 배열
   * @returns {number} 회전각 (라디안)
   */
  calculateRotation(coordinates) {
    if (coordinates.length < 2) return 0;

    // 첫 번째 변의 벡터 계산
    const vector = [
      coordinates[1][0] - coordinates[0][0],
      coordinates[1][1] - coordinates[0][1]
    ];

    return Math.atan2(vector[1], vector[0]);
  }

  /**
   * 스케일 팩터 계산
   * @param {Array} initialCoordinates - 초기 좌표
   * @param {Array} finalCoordinates - 최종 좌표
   * @returns {number} 스케일 팩터
   */
  calculateScaleFactor(initialCoordinates, finalCoordinates) {
    const initialSize = this.calculatePolygonSize(initialCoordinates);
    const finalSize = this.calculatePolygonSize(finalCoordinates);

    return Math.sqrt(
      (finalSize.width * finalSize.height) /
      (initialSize.width * initialSize.height)
    );
  }

  /**
   * 폴리곤 크기 계산
   * @param {Array} coordinates - 좌표 배열
   * @returns {Object} 크기 정보 {width, height}
   */
  calculatePolygonSize(coordinates) {
    const bounds = this.calculateBoundingBox(coordinates);

    return {
      width: bounds.maxX - bounds.minX,
      height: bounds.maxY - bounds.minY
    };
  }

  /**
   * 경계 상자 계산
   * @param {Array} coordinates - 좌표 배열
   * @returns {Object} 경계 상자 {minX, maxX, minY, maxY}
   */
  calculateBoundingBox(coordinates) {
    const xs = coordinates.map(coord => coord[0]);
    const ys = coordinates.map(coord => coord[1]);

    return {
      minX: Math.min(...xs),
      maxX: Math.max(...xs),
      minY: Math.min(...ys),
      maxY: Math.max(...ys)
    };
  }

  /**
   * 서버 전송용 데이터 포맷팅
   * @param {string} imageId - 이미지 ID
   * @param {Array} coordinates - 좌표 배열
   * @param {Array} center - 중심점
   * @param {number} scaleFactor - 스케일 팩터
   * @param {number} rotation - 회전각 (라디안)
   * @returns {Object} 서버 전송용 데이터
   */
  formatForServer(imageId, coordinates, center, scaleFactor, rotation) {
    return {
      thermalImageId: imageId,
      positionCoordinates: coordinates,
      centerCoordinate: center,
      scaleFactor: scaleFactor,
      rotation: rotation
    };
  }
}
